// Haversine formula to calculate distance between two latitude and longitude points
function getDistanceFromLatLonInMeters(lat1, lon1, lat2, lon2) {
    const R = 6371000; // Radius of the Earth in meters
    const dLat = deg2rad(lat2 - lat1); 
    const dLon = deg2rad(lon2 - lon1); 
    const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); 
    const distance = R * c; // Distance in meters
    return distance;
  }
  
  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }
  
  // Function to filter positions based on 400 meters distance
  export function filterPositions(appPositions) {
    const thresholdDistance = 200; // Set the threshold distance to 400 meters
    const filteredPositions = [];
  
    appPositions?.forEach((pos) => {
      const [lat, lon] = pos?.pos;
  
      // Only add the point if it's not too close to any of the previous filtered points
      const isFarEnough = filteredPositions?.every(filteredPos => {
        const [filteredLat, filteredLon] = filteredPos.pos; // Access the lat, lon from the previous filtered positions
        const distance = getDistanceFromLatLonInMeters(lat, lon, filteredLat, filteredLon);
        return distance > thresholdDistance;
      });
  
      if (isFarEnough) {
        filteredPositions.push(pos); // Push the entire object `pos`
      }
    });
//   console.log({appPositions,filteredPositions}, 'filteredPositionsfilteredPositionsfilteredPositions')
    return filteredPositions;
  }
  